"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.borderd = exports.container = void 0;

var react_1 = require("@emotion/react");

exports.container = react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n\n  overflow: auto;\n  white-space: pre;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n\n  & > div:last-of-type {\n    padding-right: 0px;\n  }\n"])));
exports.borderd = react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  box-shadow: inset 0 -1px 0 0 var(--gray-200);\n"])));